module.exports = __webpack_public_path__ + "static/media/c3dcef9a-9627-45d2-aa9f-3a89dcd51537_1.ed43167423d616c021d727063bf8aa5c.19266eb8.png";